var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Spinner as SpinnerIcon } from '@amsterdam/asc-assets';
import React from 'react';
import Icon from '../Icon/Icon';
import SpinnerStyle from './SpinnerStyle';
const Spinner = (_a) => {
    var { size, color } = _a, otherProps = __rest(_a, ["size", "color"]);
    return (React.createElement(SpinnerStyle, Object.assign({ size: size }, otherProps),
        React.createElement(Icon, { size: size, color: color },
            React.createElement(SpinnerIcon, null))));
};
Spinner.defaultProps = {
    size: 20,
};
export default Spinner;
//# sourceMappingURL=Spinner.js.map